import React, { memo } from 'react'
import { snakeCase } from 'lodash'
import { ListSubheader, MenuItem } from '@mui/material'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useEdges } from 'hooks/relay'
import { IndustriesList_Query } from '__generated__/IndustriesList_Query.graphql'

interface IIndustriesListProps {
  selectedValue: string | null
  onChange: (value: string) => void
}

function IndustriesList({ selectedValue, onChange }: IIndustriesListProps) {
  const data = useLazyLoadQuery<IndustriesList_Query>(graphql`
    query IndustriesList_Query {
      industries(first: 20) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `, {}, {
    fetchPolicy: 'store-and-network',
  })

  const industries = useEdges(data?.industries?.edges)

  return (
    <React.Fragment>
      <ListSubheader>
        What's your industry?
      </ListSubheader>

      {industries.map(industry => (
        <MenuItem
          key={industry.id}
          selected={industry.id === selectedValue}
          onClick={() => onChange(industry.id)}
        >
          <span data-testid={`industry-${snakeCase(industry.name)}`} data-cy={`industry-${snakeCase(industry.name)}`}>{industry.name}</span>
        </MenuItem>
      ))}
    </React.Fragment>
  )
}

export default memo(IndustriesList)
